import type { BaseUsecase } from '@usecases/base-usecase';

export interface WrapUpTimeEndedEventPublisher {
  publish(): Promise<void>;
}

export interface WrapUpTimeEndedCallUsecase extends BaseUsecase<void> {
  run(): Promise<void>;
}

export class WrapUpTimeEndedUseCase implements WrapUpTimeEndedCallUsecase {
  constructor(private publisher: WrapUpTimeEndedEventPublisher) {}

  async run(): Promise<void> {
    await this.publisher.publish();
  }
}
